import { API_ENDPOINTS } from '@/constants/api'
import { apiClient } from '@/lib/api/client'

/**
 * Users API Service
 * Handles user-related API calls (superadmin only)
 */
export const usersApi = {
  /**
   * Get users list with pagination and filters
   * @param {Object} params - { page, page_size, search, is_active, is_superuser, is_staff, ordering }
   * @returns {Promise<Object>} Users list with pagination
   */
  getUsers: async (params = {}) => {
    const response = await apiClient.get(API_ENDPOINTS.USERS.LIST, { params })
    return response
  },

  /**
   * Get single user by ID
   * @param {number} id - User ID
   * @returns {Promise<Object>} User details
   */
  getUserById: async (id) => {
    const response = await apiClient.get(
      API_ENDPOINTS.USERS.DETAIL.replace(':id', id)
    )
    return response
  },

  /**
   * Get users for autocomplete
   * @param {Object} params - { search, page, page_size }
   * @returns {Promise<Object>} Users list with pagination
   */
  getUsersAutocomplete: async (params = {}) => {
    const response = await apiClient.get(API_ENDPOINTS.USERS.AUTOCOMPLETE, { params })
    return response
  },
}

export default usersApi
